module.exports = __webpack_public_path__ + "img/big_1_63.6080d033.png";